export enum SearchParam {
  SignUp = 'signup',
  Map = 'map',
  Maps = 'maps',
  Whitepaper = 'whitepaper',
  AppUrl = 'appUrl',
  NoVideo = 'novideo',
  FullVideo = 'fullvideo',
}
